






























import { Vue, Component, Prop } from 'vue-property-decorator';
import to from 'await-to-js';
import moduleStore from '../store/migu';
import { MiguConfig } from '../utils/constant';

@Component({})
@moduleStore.initVuex({
  mutationNames: moduleStore.mutationNames,
  actionNames: moduleStore.actionNames,
})
export default class workTemplate extends Vue {

  @Prop({ default: false })
  isNewYear: boolean;

  @Prop({ default: '' })
  taskId: string;

  loading: Boolean = false;
  finished: Boolean = true;
  page: number = 1;
  pageSize: number = 10;
  total_pages: number = 0;
  list = [];
  
  async mounted() {
    await this.getList();
    this.$nextTick(() => {
      this.$emit('anchor');
    })
  }

  async getList() {
    this.loading = true;
    this.finished = false;

    const [err, res] = await to(this.$http('getTemplateList', {
      page: this.page,
      pageSize: this.pageSize,
      resourceType: 'ONE_CLICK'
    }));

    this.loading = false;
    if (err || res.code !== 200 || !res.data) {
      return;
    }
    const arr = res.data.results || [];
    this.list = this.page === 1 ? arr : [...this.list, ...arr];
    this.total_pages = res.data.total_pages;
    if (this.page >= this.total_pages) {
      this.finished = true;
    }
  }

  upLoadData() {
    if(this.page >= this.total_pages) return;
    this.page += 1;
    this.getList();
  }

  // 获取制作同款保存数据
  getSaveData(item) {
    const { styleEN, speakerSpeed, speakerName, speakerStyle, description } = item;
    const data = { text: description, styleCode: styleEN, speakerName, speakerStyle, speechSpeed: speakerSpeed };
    return JSON.stringify(data);
  }
  // 跳转播放页
  doJumpPlayPage(item) {
    localStorage.setItem('videoMiguData', this.getSaveData(item));
    const { videoUrl, coverUrl,articleId } = item;
    this.$router.push({ path: '/video-play', query: { videoUrl, coverUrl, type: '2', articleId, taskId: this.taskId } });
  }
  // 跳转制作页
  onCreateClick(item) {
    localStorage.setItem('textToVideoMiguData', this.getSaveData(item));
    try {
      if ((window as any)._amberTrack) {
        const vuid = localStorage.getItem('vuid') || '';
        (window as any)._amberTrack('music_aigc_submit_task_directly', [
          {
            EK: 'triggerType',
            EV: '2'
          },
          {
            EK: 'scene',
            EV: MiguConfig.projectId
          },
          {
            EK: 'taskId',
            EV: this.taskId
          },
          {
            EK: 'vuid',
            EV: vuid
          },
          {
            EK: 'appId',
            EV: MiguConfig.appid
          },
          {
            EK: 'channel',
            EV: MiguConfig.schannel
          }
        ], true, 'beacon');
        console.log('_amberTrack music_aigc_submit_task_directly',
        {
          EK: 'taskId',
          EV: this.taskId
        },
        {
          EK: 'vuid',
          EV: vuid
        });
      }
    } catch (e) {}
    this.$emit('reload');
  }
}
